/** PM State — global state variables and constants. */

/**
 * Format a Date object as HH:MM:SS
 * @param {Date} date - The date to format
 * @returns {string} Formatted time string
 */
window.formatTimeNow = function(date) {
  return ((date.getHours() < 10) ? "0" : "") + date.getHours() + ":" +
    ((date.getMinutes() < 10) ? "0" : "") + date.getMinutes() + ":" +
    ((date.getSeconds() < 10) ? "0" : "") + date.getSeconds();
};

window.pm_ajax_request_active = 0;
window.messages_highlighted = 1;
window.last_ads_reload = new Date().getTime();
// Avoid multiple calls of load more threads called by scroll
window.load_more_threads_active = 0;
// Avoid multiple calls of load_more_msg
window.load_more_msg_active = 0;
// Array of drafts
window.last_draft = {};
// Track if user is currently swiping/dragging on mobile
window.isDragging = false;
// Geometry threads_main_resize() last pinned onto .privateMessages. Null until
// the first layout pass, which the load diagnostics report as unknown rather
// than as a measurement.
window.pmLastLayout = {
  availableHeight: null,
  containerTop: null,
  hasNoThreads: null,
  threadOpen: null
};
// Paginated view state
window.pagedViewActive = false;
window.pagedViewCurrentPage = 1;
window.pagedViewTotalPages = 1;

window.err_div = $("<div style=\"color:red\"></div>");
window.err_txt = "Error during processing, please reload page and try again.";

window.isMarkitUpLoaded = function() {
  return typeof $.markItUp === "function";
};
